import 'css-chunksrc/client/pages/exportsPage/styles.scss';export default {
  "exportReportsPage": "_exportReportsPage_1einy_1",
  "header": "_header_1einy_11",
  "title": "_title_1einy_20",
  "subTitle": "_subTitle_1einy_27",
  "text": "_text_1einy_32",
  "profileNavigation": "_profileNavigation_1einy_38",
  "band": "_band_1einy_48",
  "description": "_description_1einy_61",
  "main": "_main_1einy_67",
  "col": "_col_1einy_77",
  "loader": "_loader_1einy_84"
};